import { render, staticRenderFns } from "./importForm.vue?vue&type=template&id=ec56bc40"
import script from "./importForm.vue?vue&type=script&lang=js"
export * from "./importForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports